;(async () => {
  const storeModuleURL = window.__GLOBAL__.assets.store
  const module = await import(storeModuleURL)
  const store = module.default

  class MainCart extends HTMLElement {
    constructor() {
      super()

      this.cartOptionProductInput = '[data-cart-option-product-checkbox]'

      this.bindEventListeners()

      store.events.subscribe('cartChange', this.render.bind(this))
      store.events.subscribe('cartLoadingChange', this.cartLoading.bind(this));

      this.validateFreeGift();
    }

    bindEventListeners() {
      document.querySelector(this.cartOptionProductInput) &&
        document
          .querySelector(this.cartOptionProductInput)
          .addEventListener('change', this.toggleCartOptionProduct.bind(this))
    }

    /**
     * Object containing key/quantity of the line items to change
     * @param {Object} updates key:quantity
     */
    async change(updates) {
      store.dispatch('updateQuantities', updates);
    }

    /**
     * Update sigle item quantity
     * @param {Object} updates key:quantity
     */
    updateItemQuantity(updates) {
      this.change(updates)
    }

    /**
     * Update multiple items
     * @param {Object} updates key:0, id:quantity
     * @param {Number} maxQuantity
     */
    updateItemsQuantity(updates, maxQuantity) {
      const currentItems = Array.from(this.querySelectorAll('cart-item'))
      const updatesId = Object.keys(updates)[1]

      if (updatesId !== undefined) {
        currentItems.forEach((cartItem, index) => {
          const variantId = cartItem.dataset.variantId
          const quantity = cartItem.querySelector(
            `#Quantity-${variantId}`
          ).value

          if (variantId == updatesId) {
            const newQuantity =
              parseInt(updates[updatesId]) + parseInt(quantity)
            updates[updatesId] =
              newQuantity > maxQuantity ? maxQuantity : newQuantity
            return
          }
        })
      }

      this.change(updates)
    }

    swapItems({itemToRemove, itemToAdd, maxQuantity}) {
      store.dispatch('swapItem', {
        itemToRemove,
        itemToAdd: {
          ...itemToAdd,
          quantity: itemToAdd.quantity <= maxQuantity ? itemToAdd.quantity : maxQuantity
        }
      })
    }

    render() {
      const sectionSelector = `#${this.id}`
      const parsedSection = new DOMParser()
        .parseFromString(store.state.cart.sections[this.id], 'text/html')
        .querySelector(sectionSelector)
      const isEmpty =
        [true, 'true'].includes(parsedSection.dataset.empty) ||
        [true, 'true'].includes(this.dataset.empty)
      this.dataset.empty = store.state.cart.item_count === 0

      this.changeCartIconState(
        [true, 'true'].includes(parsedSection.dataset.empty)
      )
      if (isEmpty) {
        document.querySelector(sectionSelector).innerHTML = this.getElementHTML(
          store.state.cart.sections[this.id],
          sectionSelector
        )
        this.renderFragments(['[data-cart-title-count]']);
        this.bindEventListeners()
        return
      }

      this.renderFragments([
        '[data-cart-title-count]',
        '[data-cart-items]',
        '[data-cart-summary]',
        '[data-cart-quick-summary]',
      ])

      this.validateFreeGift();
    }

    changeCartIconState(isEmpty = false) {
      const iconLinks = document.querySelectorAll('.js-cart-nav-link')

      iconLinks.forEach((link) => {
        if (isEmpty) {
          link.classList.remove('filled')
        } else {
          link.classList.add('filled')
        }
      })
    }

    renderFragments(fragments) {
      fragments.forEach((fragment) => {
        this.querySelector(fragment).innerHTML = this.getElementHTML(
          store.state.cart.sections[this.id],
          fragment
        )
        if(fragment == "[data-cart-title-count]"){
          document.querySelector("#head-cart-count").innerHTML = this.getElementHTML(
          store.state.cart.sections[this.id],
          fragment
        )
        }
      })
      this.bindEventListeners()
    }

    getRecommendations() {
      const recommendationsHtml = document.createElement('div')
      recommendationsHtml.innerHTML = this.parentElement.querySelector(
        '[data-cart-recommendations]'
      ).innerHTML
      const recommendationsElement = recommendationsHtml.querySelector(
        'recommended-products'
      )
      if (recommendationsElement?.classList.contains('hidden')) {
        return
      }

      this.renderRecommendations(recommendationsHtml)
    }

    renderRecommendations(recommendationsHtml) {
      const isDrawer = this.classList.contains('cart--drawer')
      const isEmpty = [true, 'true'].includes(this.dataset.empty)
      if (isDrawer && isEmpty) {
        this.querySelector('.cart__empty__content__wrapper').appendChild(
          recommendationsHtml
        )
      } else if (isDrawer) {
        this.querySelector('.cart__wrapper').appendChild(recommendationsHtml)
      }

      const quickAddButtons = Array.from(
        this.querySelectorAll('[data-button-quickadd')
      )
      quickAddButtons.map((button, index) => {
        button.addEventListener('click', (event) => {
          event.preventDefault()

          // calls the class function
          this.addItems(button.getAttribute('href'))
        })
      })
    }

    addItems(productUrl) {
      fetch(productUrl)
        .then((response) => {
          return response.text()
        })
        .then((responseText) => {
          const responseHtml = new DOMParser().parseFromString(
            responseText,
            'text/html'
          )
          const variantId = responseHtml.querySelector('input[name="id"]').value

          store.dispatch('addItems', {
            [variantId]: 1,
          })
        })
        .catch((error) => {
          console.error('Error: ', error)
        })
    }

    getElementHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector)?.innerHTML
    }

    clearCartOptionProduct() {
      this.change({
        [this.querySelector(this.cartOptionProductInput).dataset
          .cartOptionProductId]: 0,
      })
    }

    toggleCartOptionProduct(event) {
      this.change({
        [event.target.dataset.cartOptionProductId]: event.target.checked
          ? 1
          : 0,
      })
    }

    cartLoading(loading) {
      if(loading) {
        this.style.opacity = 0.3;
        this.style.pointerEvents = 'none'
      } else {
        this.style.opacity = 1;
        this.style.removeProperty('pointer-events');
      }
    }

    validateFreeGift() {
      const freeGiftDataEl = this.parentElement.querySelector('[data-sxgy]');

      if(freeGiftDataEl) {
        const freeGiftData = JSON.parse(freeGiftDataEl.innerHTML);
        const cartInfo = store.state.cart;
        const freeGiftItem = cartInfo.items.find((lineItem) => {
          return lineItem.properties.hasOwnProperty('_sxgy');
        })

        if(cartInfo.total_price > freeGiftData.threshold) {
          if(freeGiftItem == null) {
            store.dispatch('addItems', {
              [freeGiftData.id]: {
                properties: {
                  "_sxgy": "true"
                },
                quantity: 1
              }
            })
          }
        } else if (freeGiftItem) {
          this.change({
            [freeGiftItem.key]: 0
          })
        }
      }
    }
  }

  customElements.define('main-cart', MainCart)
})()
